import React from "react";

export default function GreyHeading({ text }) {
    return (
        <h3 className="text-5xl text-lk_grey_one text-center py-12">{text}</h3>
    )
}